/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import ReactQuill from "react-quill";
import { baseImage_path, baseUrl } from "../../variables/Variables";
import CKEditorField from "../../components/CKEditorField";

const SeoTags = ({ formData, setFormData }) => {
  const [ogImgFile, setOgImgFile] = useState(null);
  const [twitterImgFile, setTwitterImgFile] = useState(null);
  const [bannerImgFile, setBannerImgFile] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //   const handleImgChange = (e, fileName) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //       setOgImgFile(file);

  //       setFormData((prev) => ({
  //         ...prev,
  //         [fileName]: file,
  //       }));
  //     }
  //   };

  //   const handleTwitterImgChange = (e, fileName) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //       setTwitterImgFile(file);

  //       setFormData((prev) => ({
  //         ...prev,
  //         [fileName]: file,
  //       }));
  //     }
  //   };
  //   const handleBannerImgChnage = (e, fileName) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //       setBannerImgFile(file);

  //       setFormData((prev) => ({
  //         ...prev,
  //         [fileName]: file,
  //       }));
  //     }
  //   };

  const handleImgUpload = (e, key, setPrevieState) => {
    const file = e.target.files[0];
    if (file) {
      setPrevieState(file);
      setFormData((prev) => ({
        ...prev,
        [key]: file,
      }));
    }
  };

  return (
    <Box>
      <TextField
        label="Seo_Title"
        name="seo_title"
        value={formData.seo_title}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Meta_Title"
        name="meta_title"
        value={formData.meta_title}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />

      <Typography variant="body1" mt={2}>
        Meta Description{" "}
      </Typography>
      {/* <ReactQuill
        theme="snow"
        value={formData.meta_description}
        onChange={(value) => {
          setFormData((prev) => ({ ...prev, meta_description: value }));
        }}
        style={{ height: "200px", marginBottom: "50px" }}
      /> */}
      <CKEditorField
            value={formData.meta_description}
            onChange={(data) => setFormData((prev) => ({ ...prev, meta_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=seo`}
          />

      <TextField
        label="Meta Keywords"
        name="meta_keywords"
        value={formData.meta_keywords}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <Typography variant="body1" mt={2}>
        Custom Scripts
      </Typography>
      {/* <ReactQuill
        theme="snow"
        value={formData.custom_scripts}
        onChange={(value) =>
          setFormData((prev) => ({ ...prev, custom_scripts: value }))
        }
        style={{ height: "200px", marginBottom: "50px" }}
      /> */}
      <CKEditorField
            value={formData.custom_scripts}
            onChange={(data) => setFormData((prev) => ({ ...prev, custom_scripts: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=seo`}
          />
      <TextField
        label="OG Title"
        name="og_title"
        value={formData.og_title}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />

      <Typography variant="body1">Og Description</Typography>
      {/* <ReactQuill
        theme="snow"
        value={formData.og_description}
        onChange={(value) =>
          setFormData((prev) => ({ ...prev, og_description: value }))
        }
        style={{ height: "200px", marginBottom: "50px" }}
      /> */}
      <CKEditorField
            value={formData.og_description}
            onChange={(data) => setFormData((prev) => ({ ...prev, og_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=seo`}
          />

      <TextField
        label="OG Type"
        name="og_type"
        value={formData.og_type}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />

      <TextField
        label="OG URL"
        name="og_url"
        value={formData.og_url}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Og Locale"
        name="og_locale"
        value={formData.og_locale}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="OG Site Name"
        name="og_site_name"
        value={formData.og_site_name}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Og Image Width"
        name="og_image_width"
        value={formData.og_image_width}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Og Image Height"
        name="og_image_height"
        value={formData.og_image_height}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Og Image Type"
        name="og_image_type"
        value={formData.og_image_type}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <Typography variant="body1" mt={2}>
        Article Modified Time
      </Typography>
      <TextField
        // label="Article Modified Time"
        name="article_modified_time"
        type="datetime-local"
        value={formData.article_modified_time}
        onChange={handleChange}
        fullWidth
        // margin="normal"
      />

      <TextField
        label="Canonical Link"
        name="canonical_link"
        value={formData.canonical_link}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />

      <TextField
        label="Twitter Card"
        name="twitter_card"
        value={formData.twitter_card}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Twitter Site"
        name="twitter_site"
        value={formData.twitter_site}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Twitter Title"
        name="twitter_title"
        value={formData.twitter_title}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />

      <Typography variant="body1" mt={2}>
        Twitter Description
      </Typography>
      {/* <ReactQuill
        theme="snow"
        value={formData.twitter_description}
        onChange={(value) =>
          setFormData((prev) => ({ ...prev, twitter_description: value }))
        }
        style={{ height: "200px", marginBottom: "80px" }}
      /> */}
      <CKEditorField
            value={formData.twitter_description}
            onChange={(data) => setFormData((prev) => ({ ...prev, twitter_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=seo`}
          />

      <Box mt={2} display="flex" alignItems="center" flexWrap="wrap" gap={2}>
        <Button
          variant="contained"
          component="label"
          style={{ marginTop: "20px" }}
        >
          Upload Og Image
          <input
            type="file"
            accept="image/*"
            hidden
            onChange={(e) => handleImgUpload(e, "og_image", setOgImgFile)}
          />
        </Button>
        {formData.og_image && !(formData.og_image instanceof File) && (
          <Box mt={2}>
            <img
              src={`${baseImage_path}/${formData.og_image}`}
              alt="Og Image"
              style={{ width: "100px", height: "auto", borderRadius: "4px" }}
            />
          </Box>
        )}
        {ogImgFile && (
          <Typography
            variant="body2"
            style={{ marginTop: "10px", fontStyle: "italic" }}
          >
            Selected File : {ogImgFile.name}
          </Typography>
        )}
      </Box>

      <Box mt={2} display="flex" alignItems="center" flexWrap="wrap" gap={2}>
        <Button
          variant="contained"
          component="label"
          style={{ marginTop: "20px" }}
        >
          Upload Twitter Image
          <input
            type="file"
            accept="image/*"
            hidden
            onChange={(e) =>
              handleImgUpload(e, "twitter_image", setTwitterImgFile)
            }
          />
        </Button>
        {formData.twitter_image &&
          !(formData.twitter_image instanceof File) && (
            <Box mt={2}>
              <img
                src={`${baseImage_path}/${formData.twitter_image}`}
                alt="Twitter Image"
                style={{ width: "100px", height: "auto", borderRadius: "4px" }}
              />
            </Box>
          )}
        {twitterImgFile && (
          <Typography
            variant="body2"
            style={{ marginTop: "10px", fontStyle: "italic" }}
          >
            Selected File: {twitterImgFile.name}
          </Typography>
        )}
      </Box>

      <Box mt={2} display="flex" alignItems="center" flexWrap="wrap" gap={2}>
        <Button
          variant="contained"
          component="label"
          style={{ marginTop: "20px" }}
        >
          Upload Banner Image
          <input
            type="file"
            accept="image/*"
            hidden
            onChange={(e) => handleImgUpload(e, "banner_img", setBannerImgFile)}
          />
        </Button>
        {formData.banner_img && !(formData.banner_img instanceof File) && (
          <Box mt={2}>
            <img
              src={`${baseImage_path}/${formData.banner_img}`}
              alt="Banner Img"
              style={{ width: "100px", height: "auto", borderRadius: "4px" }}
            />
          </Box>
        )}
        {bannerImgFile && (
          <Typography
            variant="body2"
            style={{ marginTop: "10px", fontStyle: "italic" }}
          >
            Selected File: {bannerImgFile.name}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default SeoTags;
